export enum EWsErrorMessage {
  ValidationError = 'validationError',
}

export enum EWsCodeError {
  MessageHasLinkToAnotherService = 'messageHasLinkToAnotherService',
}
